import { Link } from "react-router-dom";
import { categoryList } from "@/mocks/categories";

export default function CategoryEntries() {
  const colors = [
    "bg-primary-100 text-primary-600",
    "bg-accent-100 text-accent-700",
    "bg-secondary-100 text-secondary-700",
  ];

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-6 md:py-12">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-5">
        {categoryList.map((cat, index) => (
          <Link
            key={cat.key}
            to={`/category?cat=${cat.key}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
          >
            <span
              className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-lg text-2xl transition-transform group-hover:scale-105 md:h-16 md:w-16 ${colors[index % colors.length]}`}
            >
              <i className={cat.icon}></i>
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 md:text-lg">
                {cat.name}
              </h3>
              <p className="mt-1 line-clamp-2 text-xs text-foreground-500 md:text-sm">{cat.desc}</p>
            </div>
            <span className="flex h-6 w-6 shrink-0 items-center justify-center text-foreground-300 transition-colors group-hover:text-primary-500">
              <i className="ri-arrow-right-s-line text-xl"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}